document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector('.square-container')) {
        const squareContainer = document.querySelector('.square-container');
        const squares = [];

        for (let i = 0; i < 32; i++) {
            const square = document.createElement('div');
            square.classList.add('square');
            square.style.opacity = 0.15;
            squareContainer.appendChild(square);

            squares.push(square);
        }



        const numSquaresToTurnOn = 4;
        const animationDuration = 1000;

        function shuffleArray(array) {
            for (let i = array.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [array[i], array[j]] = [array[j], array[i]];
            }
        }

        function isDiagonalToLitSquare(square) {
            const index = squares.indexOf(square);
            const diagonalIndices = [index - 5, index - 3, index + 3, index + 5];
            return diagonalIndices.some(i => i >= 0 && i < squares.length && squares[i].style.opacity === '0.6') &&
                !(diagonalIndices.includes(index - 1) || diagonalIndices.includes(index + 1));
        }

        function findNonAdjacentDiagonalLitSquare() {
            let square;
            do {
                square = squares[Math.floor(Math.random() * squares.length)];
            } while (square.style.opacity === '0.6' || isDiagonalToLitSquare(square));
            return square;
        }

        shuffleArray(squares);

        let currentIndex = 0;

        function animateStep() {
            const squaresToTurnOn = [];

            for (let i = 0; i < numSquaresToTurnOn; i++) {
                const square = findNonAdjacentDiagonalLitSquare();
                squaresToTurnOn.push(square);
            }

            squaresToTurnOn.forEach((square, index) => {
                const delay = index * (animationDuration / numSquaresToTurnOn);
                square.style.transition = `opacity ${animationDuration}ms ease-in-out ${delay}ms`;
                square.style.opacity = '0.6';
            });

            setTimeout(() => {
                squaresToTurnOn.forEach((square, index) => {
                    const delay = index * (animationDuration / numSquaresToTurnOn);
                    square.style.transition = `opacity ${animationDuration}ms ease-in-out ${delay}ms`;
                    square.style.opacity = '0.15';
                });
            }, animationDuration);

            shuffleArray(squares);

            setTimeout(animateStep, animationDuration * 2); // Allumage + extinction
        }

        animateStep();
    }
});
